import * as React from 'react';

const BlueEditIllustrationSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 201 230" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                d="M133.94 13.222h11.301c4.239 0 12.715 7.989 7.064 18.798-5.65 10.81-4.477 17.389 1.882 21.618 6.36 4.23 8.756 9.87 8.756 18.799 0 8.93-8.754 12.454-13.698 12.454h-36.892V14.632l21.587-1.41z"
                fill="#042C2D"
            />
            <path
                d="M114.444 18.155c0-8.545-6.093-15.667-14.178-17.284L79.253.524s-8.567.902-10.023 1.556C58.25 5.552 58.913 17.296 47.672 17.296c-.557 0-1.106.013-1.652.033-.328-.015-.652-.049-.984-.049-2.665 0-5.203.533-7.523 1.486-7.827 2.681-13.005 9.433-13.005 23.42 0 5.547 2.514 10.122-2.811 10.122-.408-.025-.813-.062-1.228-.062C9.535 52.246.672 61.092.672 72.003c0 10.42 8.092 18.936 18.342 19.682 5.624 1.614 10.772 1.774 16.01 1.774h14.865c.547 0 1.086-.014 1.617-.041 15.449-.77 21.085-13.98 21.085-29.417v-8.216c0-5.316 6.27-9.747 8.514-9.747h10.403c11.662 0 7.501-15.062 19.977-18.123a17.514 17.514 0 002.959-9.76"
                fill="#042C2D"
                mask="url(#blue-edit-illustration_svg__mask-2)"
                transform="translate(42.2 .407)"
            />
            <path
                fill="#042C2D"
                d="M145.892 33.28l-28.097-9.687 7.49 14.4 2.587 4.976h18.02z"
            />
            <path
                fill="#FEFEFE"
                d="M140.121 230.262H61.458L51.056 116.99H152.42z"
            />
            <path
                d="M138.48 230.262h22.436l9.605-94.68c.78-9.453-6.268-17.748-15.74-18.526l-4.322-.355-11.978 113.561z"
                fill="#A4DBE2"
            />
            <path
                d="M152.42 156.721v-39.86h-10.587l-.663 10.528-1.024 16.29c-.444 7.067 5.18 13.042 12.274 13.042M63.922 230.262l-21.432.214-11.43-94.894c-.78-9.453 6.267-17.748 15.74-18.526l4.32-.355 12.802 113.561z"
                fill="#A4DBE2"
            />
            <path
                d="M49.16 156.721v-39.86h10.587l.663 10.528 1.024 16.29c.444 7.067-5.18 13.042-12.275 13.042M130.69 32.106l11.674 29.923c.595 1.526-.532 3.171-2.173 3.171h-4.394s1.235 11.882 1.235 16.284c0 4.402 1.978 9.501-18.664 9.501-12.66 0-.726 24.83-.726 24.83s-39.834-.755-33.122-4.809c7.508-4.533 12.954-13.193 12.954-29.539 0-9.745-1.451-13.95-3.105-15.82-2.646-2.994-4.13-9.58 1.427-12.398 5.557-2.817 10.394 3.945 10.04 8.171 0 0 2.216-.794 2.216-16.414l19.391-18.184 3.247 5.284z"
                fill="#A4DBE2"
            />
            <path
                d="M118.312 91.012c-8.19 0-6.076 11.13-3.57 18.091 1.178 3.27-1.269 6.711-4.752 6.711H90.675c-4.63 0-4.25-5.641-.853-8.782 5.513-5.1 7.62-13.084 7.62-25.527 0-9.733-1.45-13.934-3.102-15.803-2.643-2.99-4.125-9.57 1.426-12.382 3.747-1.9 7.166.561 8.884 3.66 2.47 4.455 9.338 2.86 9.45-2.23a325.121 325.121 0 01.048-3.334 5.04 5.04 0 015.043-4.95h11.851"
                fill="#A4DBE2"
            />
            <path
                fill="#FEFEFE"
                d="M121.383 117.921H79.832l-1.253-12.09h44.058z"
            />
            <path
                d="M114.791 56.192c0-5.316 6.27-9.747 8.515-9.747h13.208c11.662 0 11.513-7.474 13.233-18.123l-27.31-10.277-38.678 10.277 23.718 27.87h7.314z"
                fill="#042C2D"
            />
            <path fill="#FEFEFE" d="M89.26 59.435h35.36v-6.118H89.26z" />
            <path
                fill="#FEFEFE"
                d="M129.052 56.376l-4.432 3.06v-6.119zM90.99 53.317v6.118h-3.417c-.983 0-1.78-.795-1.78-1.777v-2.563c0-.982.797-1.778 1.78-1.778h3.417z"
            />
            <path
                d="M114.79 62.992c0 .077-5.54-3.403-5.815-3.406-1.67-.021-3.344-.836-4.325-2.606-1.718-3.1-5.137-5.56-8.884-3.66-5.552 2.813-4.07 9.393-1.425 12.382 1.652 1.868 3.101 6.07 3.101 15.804l14.236-.366 3.113-18.148"
                fill="#A4DBE2"
            />
            <path
                d="M149.747 37.937s4.739-9.121 5.744-13.113c1.005-3.99-5.744-2.64-5.744-2.64l-8.062 12.792 8.062 2.96z"
                fill="#042C2D"
            />
            <path d="M0 0h201v230H0z" />
        </g>
    </svg>
);

BlueEditIllustrationSvg.displayName = 'BlueEditIllustrationSvg';
export default BlueEditIllustrationSvg;
